var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 491,
    zoomAndPan: "magnify",
    viewBox: "0 0 368.25 230.249992",
    height: 307,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c88ac8f84e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.222656 0 L 344 0 L 344 229.503906 L 0.222656 229.503906 Z M 0.222656 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5ca6d2b192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 255 180 L 367.277344 180 L 367.277344 223 L 255 223 Z M 255 180 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72bd6aaeb1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.222656 0 L 344 0 L 344 229.503906 L 0.222656 229.503906 Z M 0.222656 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9926bbfd1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.222656 0 L 367.277344 0 L 367.277344 229.503906 L 0.222656 229.503906 Z M 0.222656 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c88ac8f84e)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.611069, -0.430636, 0.430636, 0.611069, 0.764031, 194.311632)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.501182 28.499452 L 145.931661 28.498665 ",
    stroke: "#345c5b",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5ca6d2b192)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.747565, 0, 0, 0.747565, 255.079413, 180.210384)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.502283 28.499522 L 121.387198 28.499522 ",
    stroke: "#345c5b",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72bd6aaeb1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.618625, 0.41971, -0.41971, 0.618625, 24.147012, 3.021666)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.499641 28.498745 L 145.178691 28.500893 ",
    stroke: "#345c5b",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9926bbfd1f)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.606919, 0.436466, -0.436466, 0.606919, 104.537279, 0.00173928)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.49933 28.500601 L 146.197749 28.500211 ",
    stroke: "#ffb800",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.607675, 0.435412, -0.435412, 0.607675, 191.352368, 1.607632)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.500087 28.500438 L 146.617757 28.500072 ",
    stroke: "#ffb800",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0, -0.747565, 0.747565, 0, 8.004315, 222.669894)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.501356 28.498234 L 254.296977 28.498234 ",
    stroke: "#345c5b",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0, -0.747565, 0.747565, 0, 86.930631, 222.669894)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.501356 28.497519 L 254.296977 28.497519 ",
    stroke: "#ffb51a",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0, -0.747565, 0.747565, 0, 173.56358, 222.669894)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.501356 28.502561 L 254.296977 28.502561 ",
    stroke: "#ffb800",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0, -0.747565, 0.747565, 0, 255.209271, 222.669894)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 28.501356 28.501009 L 254.296977 28.501009 ",
    stroke: "#345c5b",
    strokeWidth: 57,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.203ea33f18eac05bbafc1ed5dd3d4751.svg";
export { ForwardRef as ReactComponent };